/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ReferralTypes {
    "use strict";

    export class ReferralTypesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            //this.baseEndpoint = appSettings.API_ENDPOINTS.blockType + '/' + this.selectedSection.model.id + '/Locations';
            this.baseEndpoint = appSettings.API_ENDPOINTS.referralType;
            this.sectionTemplatePath = "app/plugins/referralTypes/sectionViews/";

            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            this.buildCrudSecurityKeys(this.securityKeys.DATA_REFERRALTYPE_TAB_MAIN);
            this.entityType = 'ReferralType';
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_REFERRALTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_REFERRAL_TYPES_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.referralType, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ReferralTypeMain, null, this.securityKeys.DATA_REFERRALTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }
        get showCopy(): boolean {
            return false;
        }
        get canCopy(): boolean {
            return false;
        }
    }
}
